<template>
  <div class="container mx-auto p-5">
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      <span class="float-left mr-2">PRACTICE DETAILS</span>
      <button  @click="editDetails(true)" type="button" class="mb-2 inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <i class="fa fa-pencil-square-o mr-1 w-4" aria-hidden="true"></i>
        Edit Details
      </button>
    </h3>
    <hr />
    <div class="no-wrap md:-mx-2 mt-4">
      <!-- Left Side -->
      <div class="w-full md:mx-2 md:flex-row flex-col xl:flex">
        <div class="bg-white w-full  p-3 shadow-md rounded-sm border-2">
          
          <div class="text-gray-700">
            <div class="grid md:grid-cols-2 text-sm">
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Undergraduate College</div>
                <div class="px-4 py-2">{{ profile_data?.college }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Law School</div>
                <div class="px-4 py-2">{{ profile_data?.low_school }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Normal Hourly Rate</div>
                <div class="px-4 py-2">
                  {{ profile_data?.normal_hourly_rate }}
                </div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">
                  Number of Years in Practice
                </div>
                <div class="px-4 py-2">
                  {{ profile_data?.number_of_year_in_practice }}
                </div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">
                  Number of Attorneys in Firm
                </div>
                <div class="px-4 py-2">
                  {{ profile_data?.number_of_attorney_in_firm }}
                </div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Business</div>
                <div class="px-4 py-2">{{ profile_data?.business }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">
                  Martindale-Hubbell or other professional rating list
                </div>
                <div class="px-4 py-2">
                  {{ profile_data?.professional_rating }}
                </div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">
                  Knowledge of FMSCA and DataQ Challenges
                </div>
                <div class="px-4 py-2">{{ profile_data?.fmca_knw }}</div>
              </div>
              <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Languages Fluent</div>
                <div class="px-4 py-2">{{ profile_data.language }}</div>
              </div>
               <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Gender</div>
                <div class="px-4 py-2">{{ profile_data?.gender }}</div>
              </div>
               <div class="grid grid-cols-2">
                <div class="px-4 py-2 font-semibold">Ethnicity</div>
                <div class="px-4 py-2">{{ profile_data?.ethnicity }}</div>
              </div>
            </div>
          </div>
        </div>
         <div class="my-2"></div>
      </div>
      <!-- Right Side -->
      <div class="w-full xl:mx-2 md:flex-row flex-col xl:flex">
        <div class="bg-white md:w-full xl:w-8/12 p-3 shadow-md rounded-sm xl:mt-5 border-2 xl:mr-3">
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-user-secret"></i>
            </span>
            <span class="tracking-wide">Credentials & Insurance</span>
          </div>
          <div class="text-gray-700 mt-2 block w-full overflow-x-auto">
            <table class="divide-y divide-gray-200 w-full table-auto">
              <thead class="bg-gray-50">
                <tr>
                    <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    License State
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Bar Number
                  </th>
                    <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Date Admitted to Bar
                  </th>
                   <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Professional Liability Insurance Company
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Insurance Policy Number
                  </th>                
                  <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Insurance Issue Date
                  </th>
                    <th
                    scope="col"
                    class="px-4 py-2 text-left text-xs font-medium text-gray-500 tracking-wider"
                  >
                    Insurance Expiration Date
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(item, i) in profile_data?.credentials" :key="i">
                   <td class="px-4 py-2" v-if="!item.lic_state?.STATECD">
                    {{ item.lic_state }}
                  </td>
                    <td class="px-4 py-2" v-if="item.lic_state?.STATECD">
                    {{ item.lic_state?.STATECD }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.bar_number }}
                  </td>
                   <td class="px-4 py-2">
                    {{ setDateFormat(item.date_admitted_to_bar) }}
                  </td>
                    <td class="px-4 py-2">
                    {{ item.insurance_company }}
                  </td>
                  <td class="px-4 py-2">
                    {{ item.policy_number }}
                  </td>
                   <td class="px-4 py-2">
                    {{ setDateFormat(item.lic_issue_date) }}
                  </td>
                  <td class="px-4 py-2">
                    {{ setDateFormat(item.lic_exp_date) }}
                  </td>
                </tr>
                <tr v-if="profile_data?.credentials?.length<=0">
                  <td colspan="7" class="text-center p-3">
                    No Records Found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          <div class="my-2"></div>
        <div
          class="bg-white md:w-full xl:w-4/12 p-3 shadow-md rounded-sm xl:mt-5 xl:ml-2 border-2"
        >
          <div
            class="flex items-center space-x-2 font-semibold text-gray-900 leading-8"
          >
            <span clas="text-green-500">
              <i class="fa fa-files-o"></i>
            </span>
            <span class="tracking-wide">Attorney Files</span>
          </div>
          <div class="text-gray-700">
            <div
              class="form-group grid grid-cols-1 gap-4 mt-2"
              v-if="uploadedFiles?.length > 0"
            >
              <div
                class="col-span-6 sm:col-span-1"
                v-for="(file, i) in uploadedFiles"
                :key="i"
              >
                <div class="py-5 px-3">
                  <a
                    :href="
                      MS_BASE +
                        '/tools/download_attachment.php?filename=' +
                        BASE_S3 +
                        '/' +
                        file.Key
                    "
                    class="float-right"
                  >
                    <i class="fa fa-download cobalt-text-color"></i
                  ></a>
                  <div class="float-left mr-2" align="center">
                    <img src="@/assets/Images/file-pdf.png" />
                  </div>
                  <div class="float-left w-100">
                    <span class="">{{ file.name }}</span>
                  </div>
                </div>
                <br />
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="my-4"></div>
      </div>
    </div>
    <div id="practice_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        class="z-40 left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-5/6 md:w-full">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-2 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1">Edit Details</p>
              <i
                class="fa fa-close w-6 h-6 cursor-pointer"
                @click="editDetails(false)"
              ></i>
            </div>
            <div class="flex flex-col">
              <app-practice class="editprofile-popup-scroll" ref="child_comp_1" :forms="form"></app-practice>
              <button
                type="button"
                @click="updateAttorney()"
                class="self-end md:w-1/6 w-full mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <i
                  class="fa fa-pencil-square-o mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppPractice from "./AppPractice.vue"; // importing resuable input field
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import Constants from "../../constants.ts"; // importing constant resubale variables.
import $ from "jquery";
export default {
  name: "PracticeDetails",
  props: ["forms"],
  data: function() {
    // declaring static variable for this component
    return {
      setDateFormat:Constants.setDateFormat,
      uploadedFiles: [],
      form: this.forms,
      MS_BASE: Constants.MS_BASE,
      BASE_S3: Constants.BASE_S3,
    };
  },
  // use to import central level variables from store
  computed: mapState(["profile_data"]),
  //importing resuable components to use in current component
  components: {
    AppPractice,
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch("getFilesList", this.profile_data?.attorney_number);
    }, 1500);
  },
  created() {
    this.$store.watch(
      () => this.$store.state.attorney_files,
      (value) => {
        if (value != "") {
          this.listingUI(value);
        }
      }
    );
  },
  methods: {
    listingUI: function(data) {
      this.uploadedFiles = data.data;
    },
    updateAttorney: function() {
      this.$refs["child_comp_1"].submitApplication();
      if (
        this.$refs["child_comp_1"].v$.form.$pending ||
        this.$refs["child_comp_1"].v$.form.$error
      ) {
        this.$toast.error("please fill required fields!");
        return;
      }

      this.$store.dispatch("updateAttorneyData", {
        data: this.form,
      });
    },
    editDetails: function(value) {
      $("#practice_detail div").animate({ scrollTop: 0 }, 1000);
      if (value) {
        document.getElementById("practice_detail").classList.remove("hidden");
      } else {
        document.getElementById("practice_detail").classList.add("hidden");
        this.$store.dispatch("getAttProfileData");
      }
    },
  },
};
</script>
